import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

// STAT

const getIdentityProvidersQuery = (tenantId: string) =>
  getRanaApiV1().getQueryOptions({
    queryKey: ["tenants", tenantId, "identity-providers", "list"],
    queryFn: async () => await getRanaApiV1().TenantsApi.tenantIdentityProviders({ tenantId }),
  });

export const useIdentityProvidersQuery = (tenantId: string) => {
  return useQuery(getIdentityProvidersQuery(tenantId));
};
